import React from 'react';
import FileDropzone from './FileDropzone';
import { FOOTAGE } from '../../lib/operationCopy';

// Footage-video picker (multi-video upload, behind `multiVideoV1`). Same
// mechanics as the photo dropzone — one shared FileDropzone — with the copy and
// accept filter that match a Brinno-style multi-file shoot.
//
// `accept` is deliberately broader than the single-video flow's ".mp4": a long
// shoot arrives as .MP4/.AVI/.MOV straight off the card, and the browser leaves
// `File.type` empty for several of those, so the extension list carries the
// filter (videoScan.js re-checks it).

const VideoStackIcon = () => (
  <svg
    className="pi-footage-tile-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="6.5" y="7.5" width="15" height="12" rx="2" />
    <path d="M4 16.5V5.5a2 2 0 0 1 2-2h11" />
    <path d="M6.5 11h15" />
    <path d="m12 13.6 4 2.3-4 2.3z" />
  </svg>
);

export const VIDEO_ACCEPT = 'video/*,.mp4,.m4v,.mov,.avi,.mkv,.mts,.m2ts,.webm';

// One noun for the files this picker takes: "clips" (lib/operationCopy). The
// subtitles already said clip; the titles and the button said videos, which is
// the word this project reserves for the ONE video a combine produces.
const VideoDropzone = ({ onFiles, title, subtitle, disabled, variant }) => (
  <FileDropzone
    onFiles={onFiles}
    accept={VIDEO_ACCEPT}
    multiple
    icon={<VideoStackIcon />}
    title={title || `${variant === 'tile' ? 'Upload' : 'Add'} ${FOOTAGE.plural}`}
    subtitle={subtitle || (variant === 'tile'
      ? 'Pick every clip from the shoot — cameras split long recordings into many files'
      : 'Pick every clip from the shoot. We keep them in recording order.')}
    ctaLabel={`Choose ${FOOTAGE.plural}`}
    disabled={disabled}
    variant={variant}
    testId="video-dropzone"
    inputTestId="multi-video-input"
  />
);

export default VideoDropzone;
